(() => {
  const drawerId = 'Cart-Drawer';
  const openClass = 'is-open';
  const emitEvent = (name, detail) => {
    if (typeof dispatchCustomEvent === 'function') {
      dispatchCustomEvent(name, detail);
    } else {
      document.dispatchEvent(new CustomEvent(name, { detail }));
    }
  };

  const sectionsToRender = () => [
    {
      id: drawerId,
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }
  ];

  const parseSectionHtml = (html, selector) => {
    const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return parsed ? parsed.innerHTML : '';
  };

  const renderSections = (parsedState) => {
    const sections = sectionsToRender();
    sections.forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) ||
        document.getElementById(section.id);

      if (parsedState.sections && parsedState.sections[section.section]) {
        elementToReplace.innerHTML = parseSectionHtml(parsedState.sections[section.section], section.selector);
      } else if (parsedState[section.section]) {
        elementToReplace.innerHTML = parseSectionHtml(parsedState[section.section], section.selector);
      }
    });

    const cartDrawer = document.getElementById(drawerId);
    cartDrawer?.removeProductEvent?.();
    cartDrawer?.notesToggle?.();
  };

  const closeAllMenus = () => {
    document.querySelectorAll('[data-cart-subscription]').forEach((wrapper) => {
      const trigger = wrapper.querySelector('[data-cart-subscription-trigger]');
      const menu = wrapper.querySelector('[data-cart-subscription-menu]');
      if (!trigger || !menu) return;
      trigger.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
      wrapper.classList.remove(openClass);
    });
  };

  const toggleMenu = (wrapper) => {
    const trigger = wrapper.querySelector('[data-cart-subscription-trigger]');
    const menu = wrapper.querySelector('[data-cart-subscription-menu]');
    if (!trigger || !menu) return;

    const isOpen = wrapper.classList.contains(openClass);
    closeAllMenus();
    const nextOpenState = !isOpen;
    wrapper.classList.toggle(openClass, nextOpenState);
    trigger.setAttribute('aria-expanded', String(nextOpenState));
    menu.hidden = !nextOpenState;
  };

  const setLoadingState = (wrapper, isLoading) => {
    const trigger = wrapper.querySelector('[data-cart-subscription-trigger]');
    const line = wrapper.dataset.line;
    const lineItem = document.getElementById(`CartDrawerItem-${line}`);

    trigger?.classList.toggle('is-loading', isLoading);
    if (isLoading) {
      trigger?.setAttribute('disabled', 'true');
      lineItem?.classList.add('thb-loading');
    } else {
      trigger?.removeAttribute('disabled');
      lineItem?.classList.remove('thb-loading');
    }
  };

  const updateSellingPlan = async (wrapper, sellingPlanId) => {
    const line = Number(wrapper.dataset.line);
    const quantity = Number(wrapper.dataset.quantity) || 1;
    const body = JSON.stringify({
      line,
      quantity,
      selling_plan: sellingPlanId || null,
      sections: sectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    setLoadingState(wrapper, true);
    emitEvent('line-item:change:start', {
      line,
      selling_plan: sellingPlanId
    });

    try {
      const response = await fetch(theme.routes.cart_change_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body
      });

      const stateText = await response.text();
      const parsedState = JSON.parse(stateText);

      renderSections(parsedState);

      emitEvent('line-item:change:end', {
        line,
        selling_plan: sellingPlanId,
        cart: parsedState
      });
    } catch (error) {
      console.error('Failed to update subscription option', error);
      const labelEl = wrapper.querySelector('.cart-subscription__label');
      if (labelEl) {
        const initialLabel = wrapper.dataset.initialLabel || 'One-time purchase';
        labelEl.textContent = initialLabel;
      }
    } finally {
      setLoadingState(wrapper, false);
    }
  };

  document.addEventListener('click', (event) => {
      const optionButton = event.target.closest('[data-cart-subscription-option]');
      const triggerButton = event.target.closest('[data-cart-subscription-trigger]');

    if (optionButton) {
      const wrapper = optionButton.closest('[data-cart-subscription]');
      if (!wrapper) return;

      const menu = wrapper.querySelector('[data-cart-subscription-menu]');
      const trigger = wrapper.querySelector('[data-cart-subscription-trigger]');
      const labelEl = wrapper.querySelector('.cart-subscription__label');
      const isOneTime = !optionButton.dataset.sellingPlanId;
      const chosenLabel = isOneTime
        ? wrapper.dataset.oneTimeLabel || 'SUBSCRIBE & SAVE 5%'
        : optionButton.textContent.trim();

      labelEl && (labelEl.textContent = chosenLabel);
      trigger && trigger.setAttribute('aria-expanded', 'false');
      menu && (menu.hidden = true);
      wrapper.classList.remove(openClass);
      wrapper.classList.toggle('is-one-time', isOneTime);

      updateSellingPlan(wrapper, optionButton.dataset.sellingPlanId);
      return;
    }

    if (triggerButton) {
      const wrapper = triggerButton.closest('[data-cart-subscription]');
      if (wrapper) {
        toggleMenu(wrapper);
      }
      return;
    }

    if (!event.target.closest('[data-cart-subscription]')) {
      closeAllMenus();
    }
  });
})();
